import { createApiRequest } from "../common";
import { GetOrgThemeRequestContent, GetOrgThemeResponseContent } from '@equaliq/api-model';

export const getOrgThemeApi = async (request: GetOrgThemeRequestContent): Promise<GetOrgThemeResponseContent> => {
  const apiRequest = createApiRequest<GetOrgThemeResponseContent>('post', '/orgs/getOrgTheme');
  return apiRequest(request);
};
